import { User } from '@/entities/User'
import { CourseBooking } from '@/entities/CourseBooking'

export class Appointment {
  id = -1
  courseId = -1
  begin = new Date()
  end = new Date()
  availablePlaces = -1
  courseBookingList: CourseBooking[] = []

  static emptyAppiontment () {
    return new Appointment()
  }

  static newAppiontment (id:number, courseId:number, begin:Date, end:Date,
    availablePlaces:number, courseBookingList: CourseBooking[]) {
    const appointment = new Appointment()

    appointment.id = id
    appointment.courseId = courseId
    appointment.begin = begin
    appointment.end = end
    appointment.availablePlaces = availablePlaces
    appointment.courseBookingList = courseBookingList

    return appointment
  }

  copyAppiontment (appointmentToCopy:Appointment) {
    this.id = appointmentToCopy.id
    this.courseId = appointmentToCopy.courseId
    this.begin = appointmentToCopy.begin
    this.end = appointmentToCopy.end
    this.availablePlaces = appointmentToCopy.availablePlaces
    this.courseBookingList = appointmentToCopy.courseBookingList
  }
}
